
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    OPER: "OPER",
    TOFF: "TOFF",
    FLIGHT: "FLIGHT",
    MAINT: "MAINT",
    STOR: "STOR",
    TRAN: "TRAN"
};
